module.exports = __webpack_public_path__ + "images/embed/tag_close.png";